import { render, staticRenderFns } from "./BaseTabBar.vue?vue&type=template&id=2a611728&scoped=true&"
import script from "./BaseTabBar.vue?vue&type=script&lang=js&"
export * from "./BaseTabBar.vue?vue&type=script&lang=js&"
import style0 from "./BaseTabBar.vue?vue&type=style&index=0&id=2a611728&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a611728",
  null
  
)

export default component.exports